export default __webpack_public_path__ + "static/media/TRIG.86d68826.png";